import React from 'react';

type TabOption = {
  label: string;
  value: string;
};

type TabNavigationProps = {
  tabs: TabOption[];
  activeTab: string;
  onTabChange: (value: string) => void;
};

const TabNavigation: React.FC<TabNavigationProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <ul className='flex mb-4'>
      {tabs.map((tab) => (
        <li key={tab.value}>
          <button
            onClick={() => onTabChange(tab.value)}
            className={`${
              activeTab === tab.value ? 'border-b-2 border-b-red-5 bg-red-1' : 'bg-gray-1'
            } text-sm pl-2 pr-12 py-2 text-[#2E3031] rounded-sm`}>
            {tab.label}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default TabNavigation;
